import "core-js/modules/es6.object.assign";
import * as tslib_1 from "tslib";
import React from "react";
import { renderablePropType } from "../prop-types-extensions";
import { forwardRefAs } from "./exotic";
import { ThemeContext } from "./theme";
export var Generic = forwardRefAs(function (_a, ref) {
  var as = _a.as,
      rest = tslib_1.__rest(_a, ["as"]);

  return React.createElement(ThemeContext.Consumer, null, function (_ref) {
    var transform = _ref.transform;
    return React.createElement(as, Object.assign({
      ref: ref
    }, transform(rest, "Generic")));
  });
}, {
  as: "div"
});
Generic.displayName = "Generic";
Generic.propTypes = {
  as: renderablePropType
};